import React, { useState } from "react";
import { motion } from "framer-motion";

export const RaceRegulations = () => {
  const [activeIndex, setActiveIndex] = useState(0); // Default to first item open

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const regulations = [
    {
      title: "PERSYARATAN KEIKUTSERTAAN",
      content: `
        Peserta lomba lari trail wajib:
         <ul class="list-disc pl-5 mt-2">
          <li>Memahami durasi dan karakteristik lomba serta telah mempersiapkan diri dengan baik.</li>
          <li>Memahami sifat unik dan persyaratan lomba lari trail, termasuk berlari di medan pegunungan pada malam atau pagi hari, dan telah menjalani latihan yang diperlukan.</li>
          <li>Bertanggung jawab atas diri sendiri dan memiliki kemampuan untuk mengatasi masalah yang mungkin timbul selama lomba, seperti kelelahan, masalah pencernaan, nyeri otot atau sendi, dan cedera ringan.</li>
          <li>Memahami bahwa penyelenggara tidak bertanggung jawab untuk membantu mengatasi masalah tersebut, dan keselamatan peserta bergantung pada kemampuan mereka sendiri untuk mengantisipasi dan menyesuaikan diri dengan potensi masalah.</li>
        </ul>
      `,
    },

    {
      title: "KEBIJAKAN PENDAFTARAN",
      content: `
    Dengan melakukan pendaftaran, peserta dianggap menyetujui ketentuan berikut:
    <ul class="list-disc pl-5 mt-2">
      <li>Biaya pendaftaran tidak dapat dikembalikan atau dibatalkan.</li>
      <li>Transfer BIB dapat dilakukan dalam periode waktu tertentu dengan menghubungi nomor atau email pada halaman kontak.</li>
      <li>Penggunaan BIB milik pelari lain dilarang karena alasan keselamatan dan kualifikasi, dan akan mengakibatkan diskualifikasi.</li>
    </ul>
  `,
    },

    {
      title: "MANDATORY GEARS",
      content: `
    Peserta wajib membawa Mandatory Gears (Peralatan Wajib) sesuai kategori lomba (lihat pada halaman detail kategori). 
    <ul class="list-disc pl-5 mt-2">
      <li>Tidak membawa peralatan wajib akan dikenakan penalti.</li>
      <li>Marshal berhak memeriksa isi vest/belt peserta secara acak, dan peserta wajib mematuhi pemeriksaan tersebut.</li>
      <li>Marshal berhak mendiskualifikasi peserta yang tidak mematuhi pemeriksaan.</li>
    </ul>
  `,
    },

    {
      title: "WATER STATIONS",
      content: `
    Makanan dan minuman disediakan di tiga lokasi berbeda sepanjang rute, yaitu WS Kandang Badak, WS Surken, dan WS Putri. <br/><br/>
    Water stations menyediakan:
    <ul class="list-disc pl-5 mt-2">
      <li>Air mineral, minuman berkarbonasi, isotonik, serta buah-buahan.</li>
      <li>Peserta wajib membawa foldable cup untuk menghindari penggunaan plastik sekali pakai.</li>
    </ul>
  `,
    },

    {
      title: "BANTUAN MEDIS",
      content: `
    Penyelenggara menyediakan tim medis di beberapa lokasi untuk memberikan pertolongan pertama apabila diperlukan. Meskipun demikian, setiap peserta tetap memiliki tanggung jawab penuh atas kondisi dan keselamatan dirinya sendiri selama mengikuti lomba.<br/><br/>
    Tim medis berwenang untuk:
  <ul class="list-disc pl-5 mt-2">
      <li>Menghentikan peserta apabila dinilai tidak layak untuk melanjutkan lomba.</li>
      <li>Mengevakuasi peserta yang berada dalam situasi berbahaya.</li>
      <li>Merujuk peserta ke fasilitas kesehatan apabila diperlukan.</li>
    </ul>
  `,
    },
    {
      title: "SURAT SEHAT",
      content: `
    Peserta wajib membawa surat sehat yang menyatakan bahwa mereka secara fisik layak untuk mengikuti lomba. Surat sehat ini harus diterbitkan maksimal 7-hari sebelum lomba dan dapat diperoleh dari klinik, rumah sakit, atau dokter. Tanpa surat sehat, peserta tidak akan menerima nomor lomba (BIB).
  `,
    },

    {
      title: "PENANDA JALAN",
      content: `
        Rute ditandai dengan pita, signage, dan tanda lainnya, dengan bagian reflektif untuk visibilitas malam. Petugas lomba akan ditempatkan di sepanjang rute dan persimpangan. Ikuti petunjuk petugas. Tanda dipasang sebelum lomba dan dihapus setelahnya. Untuk pertimbangan lingkungan, cat tidak digunakan sebagai penanda.
      `,
    },
    {
      title: "BERHENTI DARI LOMBA",
      content: `
    Dalam situasi peserta memutuskan atau terpaksa berhenti dari lomba, berlaku ketentuan berikut:
    <ul class="list-disc pl-5 mt-2">
      <li>Peserta yang berhenti disarankan segera melapor ke petugas.</li>
      <li>Peserta yang berhenti tidak diperkenankan melanjutkan lomba.</li>
    </ul>
  `,
    },

    {
      title: "TINDAKAN DILARANG",
      content: `
    Peserta dilarang melakukan tindakan berikut selama perlombaan:
    <ul class="list-disc pl-5 mt-2">
      <li>Memotong jalur.</li>
      <li>Membuang sampah.</li>
      <li>Tidak membawa peralatan wajib.</li>
      <li>Mendampingi pelari tanpa registrasi.</li>
      <li>Melakukan kecurangan (misalnya menggunakan transportasi lain).</li>
      <li>Melanggar instruksi petugas.</li>
      <li>Menggunakan doping.</li>
    </ul><br/>
    Pelanggaran atas ketentuan di atas dapat dikenakan sanksi berupa penalti atau diskualifikasi, sesuai keputusan panitia.
  `,
    },

    {
      title: "TANGGUNG JAWAB DAN PENGHENTIAN LOMBA",
      content: `
    Setiap peserta bertanggung jawab atas keselamatan diri dan segala risiko yang mungkin timbul selama lomba. Penyelenggara tidak bertanggung jawab atas kerusakan properti pribadi yang terjadi di luar kendali.<br/><br/>
    Lomba dapat dihentikan sementara atau dipersingkat apabila terjadi kondisi darurat, termasuk namun tidak terbatas pada:
  <ul class="list-disc pl-5 mt-2">
      <li>Peringatan cuaca ekstrem.</li>
      <li>Bencana alam (mengacu pada informasi resmi BMKG).</li>
    </ul>
  `,
    },

    {
      title: "HAK MEDIA DAN PUBLIKASI",
      content: `
        Dengan berpartisipasi, peserta setuju bahwa:
      <ul class="list-disc pl-5 mt-2">
          <li>Penyelenggara berhak mengambil dan menggunakan foto, video, hasil lomba, dan konten media lainnya selama dan setelah acara untuk keperluan promosi, pemasaran, dan editorial di berbagai platform, termasuk surat kabar, televisi, majalah, situs web, dan media sosial.</li>
          <li>Peserta memberikan lisensi bebas royalti, worldwide, dan abadi kepada penyelenggara untuk menggunakan gambar, nama, dan hasil lomba tanpa kompensasi atau pemberitahuan tambahan.</li>
          <li>Penyelenggara memiliki semua hak atas media resmi acara dan dapat mendistribusikan konten sesuai kebijakan mereka.</li>
          <li>Peserta yang tidak ingin ditampilkan dalam media terkait acara harus mengajukan permintaan tertulis kepada penyelenggara sebelum hari lomba.</li>
        </ul>
      `,
    },
    {
      title: "KELUHAN DAN PROTES",
      content: `
        Semua keberatan terhadap keputusan panitia atau rute lomba harus disampaikan secara tertulis, disertai dengan deposit Rp1.000.000 (tidak dapat dikembalikan jika keberatan dianggap tidak valid), dalam waktu dua jam setelah peserta tiba di garis finish. Hakim lomba, yang terdiri dari:
      <ul class="list-disc pl-5 mt-2">
          <li>Juri Lari.</li>
           <li>Race Director.</li>
          <li>Perwakilan ALTI.</li>
          <li>Pihak kompeten yang dipilih oleh direktur lomba.</li>
        </ul> <br/>
        Hakim lomba berwenang membuat keputusan final yang tidak dapat diganggu gugat.
      `,
    },
  ];

  return (
    <section
      id="race-regulations"
      className="w-full min-h-screen py-20 text-center text-lime-600 flex flex-col justify-center relative bg-white"
    >
      <div className="relative z-0 container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-6xl mx-auto space-y-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="join join-vertical ">
                {regulations.map((reg, index) => (
                  <div
                    key={index}
                    className="collapse collapse-arrow join-item group"
                  >
                    <input
                      type="radio"
                      name="race-regulations-accordion"
                      checked={activeIndex === index}
                      onChange={() => toggleAccordion(index)}
                    />
                    <div
                      className={`collapse-title text-left text-base font-medium uppercase  transition-colors duration-200
          ${activeIndex === index ? "text-lime-600" : "text-gray-600"} 
          group-hover:text-lime-600`}
                    >
                      {reg.title}
                    </div>
                    <div
                      className="collapse-content text-left text-base text-gray-600"
                      dangerouslySetInnerHTML={{ __html: reg.content }}
                    />
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
